if (!customElements.get('almila-footer')) {
  customElements.define('almila-footer', class AlmilaFooter extends HTMLElement {
    constructor() {
      super();
      this.onBreakpointChange = () => this.disclosures.forEach((disclosure) => {
        // A panel that holds focus stays open when the screen narrows to phone width.
        if (this.mobileQuery.matches && disclosure.panel.contains(this.ownerDocument.activeElement)) {
          disclosure.expanded = true;
        }
        this.updateDisclosure(disclosure);
      });
    }

    connectedCallback() {
      // Phones fold the links menu and the opening hours (22 Oct 2026; the address stays in view since 23 Oct)
      // behind toggles; wider screens show both open. The menu also swaps its heading for its toggle.
      this.disclosures = [
        {
          toggle: this.querySelector('[data-footer-toggle]'),
          panel: this.querySelector('[data-footer-menu]'),
          heading: this.querySelector('[data-footer-menu-heading]'),
          expanded: false,
          onToggle: null
        },
        {
          toggle: this.querySelector('[data-footer-visit-toggle]'),
          panel: this.querySelector('[data-footer-visit]'),
          heading: null,
          expanded: false,
          onToggle: null
        }
      ].filter((disclosure) => disclosure.toggle && disclosure.panel);
      if (!this.disclosures.length) return;

      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.disclosures.forEach((disclosure) => {
        disclosure.onToggle = () => {
          disclosure.expanded = !disclosure.expanded;
          this.updateDisclosure(disclosure);
        };
        disclosure.toggle.addEventListener('click', disclosure.onToggle);
        this.updateDisclosure(disclosure);
      });
      this.mobileQuery.addEventListener('change', this.onBreakpointChange);
    }

    disconnectedCallback() {
      this.disclosures?.forEach((disclosure) => disclosure.toggle.removeEventListener('click', disclosure.onToggle));
      this.mobileQuery?.removeEventListener('change', this.onBreakpointChange);
    }

    updateDisclosure(disclosure) {
      const { toggle, panel, heading } = disclosure;
      const mobile = this.mobileQuery.matches;
      const active = this.ownerDocument.activeElement;
      if (mobile) {
        toggle.hidden = false;
        if (heading && (active === heading || heading.contains(active))) {
          toggle.focus();
        }
      }
      if (heading) heading.hidden = mobile;
      panel.hidden = mobile && !disclosure.expanded;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));

      // Move focus to what the toggle opened (the menu's heading) before hiding the toggle on wider screens.
      if (!mobile && active === toggle) {
        const target = heading || panel.firstElementChild;
        target.setAttribute('tabindex', '-1');
        target.focus();
      }
      toggle.hidden = !mobile;
    }
  });
}
